import {routerConfig} from "./RouterConfig";

import Components from "./components";
import Equity from "./equity";
import Pipes from "./pipes";
import Services from "./services";
import {AccountStore} from "./store/AccountStore";

const ModuleName = "tfApp.account";

export default angular.module(ModuleName, [Components(), Equity(), Pipes(ModuleName), Services()])
                      .config(routerConfig)
                      .service(AccountStore.id, AccountStore)
                      .name;
